(function (window, document) {
  "use strict";

  /*
    ===============================================================================
    NUPEP Shopify Framework
    Product Engine
    Version: 3.0.0
    ===============================================================================
    */

  if (!window.NUPEP) {
    console.error("[NUPEP Product] Core framework not found.");
    return;
  }

  if (!window.NUPEP.Events) {
    console.error("[NUPEP Product] Events Engine not found.");
    return;
  }

  /*
    ===============================================================================
    Private Product State
    ===============================================================================
    */

  let state = {
    variantId: null,

    sellingPlanId: null,

    purchaseType: "one-time",

    quantity: 1,

    price: 0,

    compareAtPrice: 0,

    available: true,

    currency: "GBP",
  };

  /*
    ===============================================================================
    Private Helpers
    ===============================================================================
    */

  function cloneState() {
    return structuredClone(state);
  }

  function emit(eventName) {
    NUPEP.Events.emit(
      eventName,

      cloneState(),
    );
  }

  /*
    ===============================================================================
    Product Engine
    ===============================================================================
    */

  const Product = {
    /*
        --------------------------------------------------------------------------
        Initialize
        --------------------------------------------------------------------------
        */

    init() {
      console.log("[NUPEP Product] Initializing...");

      this.detectVariant();

      this.detectQuantity();

      emit(NUPEP.Events.NAMES.PRODUCT_INIT);

      console.log("[NUPEP Product] Ready", cloneState());
    },

    /*
        --------------------------------------------------------------------------
        Variant
        --------------------------------------------------------------------------
        */

    detectVariant() {
      const input = document.querySelector(
        'form[action*="/cart/add"] input[name="id"]',
      );

      if (!input) return;

      state.variantId = input.value;
    },

    setVariant(id) {
      if (state.variantId === id) return;

      state.variantId = id;

      emit(NUPEP.Events.NAMES.VARIANT_CHANGE);
    },

    getVariant() {
      return state.variantId;
    },

    /*
        --------------------------------------------------------------------------
        Selling Plan
        --------------------------------------------------------------------------
        */

    setSellingPlan(id) {
      if (state.sellingPlanId === id) return;

      state.sellingPlanId = id;

      emit(NUPEP.Events.NAMES.SELLING_PLAN_CHANGE);
    },

    getSellingPlan() {
      return state.sellingPlanId;
    },

    /*
        --------------------------------------------------------------------------
        Purchase Type
        --------------------------------------------------------------------------
        */

    setPurchaseType(type) {
      if (state.purchaseType === type) return;

      state.purchaseType = type;

      emit(NUPEP.Events.NAMES.PURCHASE_TYPE_CHANGE);
    },

    getPurchaseType() {
      return state.purchaseType;
    },

    /*
        --------------------------------------------------------------------------
        Quantity
        --------------------------------------------------------------------------
        */

    detectQuantity() {
      const input = document.querySelector('input[name="quantity"]');

      if (!input) return;

      state.quantity = parseInt(input.value || 1);
    },

    setQuantity(quantity) {
      quantity = parseInt(quantity);

      if (isNaN(quantity) || quantity < 1) {
        quantity = 1;
      }

      if (state.quantity === quantity) return;

      state.quantity = quantity;

      emit(NUPEP.Events.NAMES.QUANTITY_CHANGE);
    },

    getQuantity() {
      return state.quantity;
    },

    /*
        --------------------------------------------------------------------------
        Price
        --------------------------------------------------------------------------
        */

    setPrice(price) {
      state.price = Number(price);

      emit(NUPEP.Events.NAMES.PRICE_CHANGE);
    },

    getPrice() {
      return state.price;
    },

    /*
        --------------------------------------------------------------------------
        Compare At Price
        --------------------------------------------------------------------------
        */

    setComparePrice(price) {
      state.compareAtPrice = Number(price);

      emit(NUPEP.Events.NAMES.COMPARE_PRICE_CHANGE);
    },

    getComparePrice() {
      return state.compareAtPrice;
    },

    /*
        --------------------------------------------------------------------------
        Availability
        --------------------------------------------------------------------------
        */

    setAvailability(status) {
      state.available = Boolean(status);

      emit(NUPEP.Events.NAMES.AVAILABILITY_CHANGE);
    },

    isAvailable() {
      return state.available;
    },

    /*
        --------------------------------------------------------------------------
        Currency
        --------------------------------------------------------------------------
        */

    setCurrency(currency) {
      state.currency = currency;
    },

    getCurrency() {
      return state.currency;
    },

    /*
        --------------------------------------------------------------------------
        Read Entire State
        --------------------------------------------------------------------------
        */

    getState() {
      return cloneState();
    },

    /*
        --------------------------------------------------------------------------
        Reset Product
        --------------------------------------------------------------------------
        */

    reset() {
      state.sellingPlanId = null;

      state.purchaseType = "one-time";

      state.quantity = 1;

      emit(NUPEP.Events.NAMES.PRODUCT_RESET);
    },
  };

  /*
    ===============================================================================
    Register Module
    ===============================================================================
    */

  Object.freeze(Product);

  window.NUPEP.Product = Product;

  /*
    ===============================================================================
    Bootstrap
    ===============================================================================
    */

  document.addEventListener("DOMContentLoaded", () => {
    Product.init();
  });
})(window, document);
